<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>ID：</label>
                <el-input v-model="search_Obj.member_id" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>昵称：</label>
                <el-input v-model="search_Obj.f_nickname" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_username" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>编号：</label>
                <el-input v-model="search_Obj.f_member_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>是否关注：</label>
                <el-select v-model="search_Obj.f_is_sub" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('yesNo')" :key="'is_sub'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>注册时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:320px">
                </el-date-picker>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" v-loading="loading" border stripe>
                <el-table-column prop="id" label="ID" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="nickname" label="昵称" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="username" label="邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="member_code" label="编号" sortable="custom"></el-table-column>
                <el-table-column prop="car_count" label="车辆数量" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="regtime" label="注册时间" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ formatDate(scope.row.regtime, "yyyy-mm-dd") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="is_sub" label="关注" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.is_sub, "yesNo") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="point" label="积分" sortable="custom"></el-table-column>
                <el-table-column prop="vip" label="会员" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.vip, "yesNo") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="vip_expiration_date" label="会员时间" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看会员"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
        <PointLog
            width="1200px"
            :member_id="model_id"
            title="积分日志"
            :isshow="pointShow"
            @on-close="closePointDialog">
        </PointLog>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import PointLog from "../memberpointlog/list"
import listutil from "@/libs/listutil"

export default {
    name: 'memberList',
    mixins: [listutil],
    components: {Edit, Info, PointLog, Btns, LabBtns},
    data() {
        return {
            m_name: '会员',
            menu_id: 2100,
            list_url: "/api/admin/member/list",
            search_Obj: {
                member_id: '',
                f_nickname: '',
                f_username: '',
                f_member_code: '',
                f_is_sub: '',
                f_regtime_s_date: '',
                f_regtime_e_date: ''
            },
            del_Obj:{
                url:'/api/admin/member/del',
                data:{
                    ids:''
                }
            },
            enu_name: ["yesNo"],
            dateRange: '',
            pointShow: false,
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_regtime_s_date = val[0]
                this.search_Obj.f_regtime_e_date = val[1]
            }else{
                this.search_Obj.f_regtime_s_date = ''
                this.search_Obj.f_regtime_e_date = ''
            }
        },
        showPointLog(index, row){
            this.model_id = row.id
            this.pointShow = true
        },
        closePointDialog() {
            this.pointShow = false
            this.getListData()
        },
    }
};
</script>